import {
  parsePublicConfig,
  pickPublicConfig,
  PUBLIC_CONFIG_ELEMENT_ID,
  PUBLIC_ENVIRONMENT_KEY,
  type PublicConfig,
  type PublicConfigKey,
} from "@shared/deployment/public-config";

function readBrowserConfig(): PublicConfig {
  const text = document.getElementById(PUBLIC_CONFIG_ELEMENT_ID)?.textContent;
  return text ? parsePublicConfig(text) : {};
}

function readServerValue(key: PublicConfigKey): string | undefined {
  const value = process.env[key]?.trim();
  return value ? value : undefined;
}

export function publicConfigValue(key: PublicConfigKey): string | undefined {
  if (typeof window === "undefined") return readServerValue(key);
  return readBrowserConfig()[key];
}

export function requiredPublicConfigValue(key: PublicConfigKey): string {
  const value = publicConfigValue(key);
  if (!value) throw new Error(`${key} is not configured for this deployment.`);
  return value;
}

export function currentPublicConfig(): PublicConfig {
  if (typeof window === "undefined") return pickPublicConfig(readServerValue);
  return readBrowserConfig();
}

export function publicEnvironment(): string {
  return (
    publicConfigValue(PUBLIC_ENVIRONMENT_KEY) ??
    (process.env.NODE_ENV === "production" ? "production" : "development")
  );
}

export function isProductionEnvironment(): boolean {
  return publicEnvironment() === "production";
}
